import { LegalLayout } from "./layout"

export function KvkkPage() {
  return (
    <LegalLayout title="KVKK aydınlatma metni">
      <p>
        KVKK kapsamında veri sorumlusu sıfatıyla işlenen kişisel veriler ve haklar bu sayfada
        listelenir.
      </p>
    </LegalLayout>
  )
}
